import { ICatalogFilterValue } from '../api/getCatalogFilterState/types';

interface Item {
  id: number;
  title: string;
  value: string;
}

interface Group {
  id: number;
  group: string;
  items: Item[];
}
export function groupBrandsByAlphabet(brands: ICatalogFilterValue[]) {
  const alphabetGroups: {
    [key: string]: Item[];
  } = {};

  brands.forEach((item) => {
    const firstChar = item.code[0];
    const groupKey = /\d/.test(firstChar) ? '0-9' : firstChar.toUpperCase();

    if (!alphabetGroups[groupKey]) {
      alphabetGroups[groupKey] = [];
    }

    alphabetGroups[groupKey].push({
      id: alphabetGroups[groupKey].length + 1,
      title: item.code,
      value: item.value,
    });
  });

  const result: Group[] = Object.keys(alphabetGroups)
    .sort()
    .map((group, index) => ({
      id: index + 1,
      group: group,
      items: alphabetGroups[group],
    }));

  return result;
}
